import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgArrowUp = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.0437 5.74231L12.0437 20L9.95633 20L9.95633 5.74231L5.47597 9.93864L4 8.55624L11 2L18 8.55624L16.524 9.93864L12.0437 5.74231Z"
      fill="currentColor"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgArrowUp);

export default ForwardRef;
